import React from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../DAL/store";
import {PluginsPopupLg} from "./plugins-popup-lg";
import {PluginsPopupMobile} from "./plugins-popup-mobile";
import {Popup} from "../../../../ui/popup/popup";
import {useWindowSize} from "../../../../domain/common";
import {DESKTOP_BREAKPOINT, MOBILE_BREAKPOINT} from "../../../../domain/animations/animations-provider";

interface IPluginsPopupProps {
    close?: Function,
}
export const PluginsPopup = (props : IPluginsPopupProps) => {

    const ShowSortChoices = useAppSelector((store) => store.ShowSortChoices);
    const dispatch = useAppDispatch();

    const HideSortOptions = (dispatch :any) => {

        if(ShowSortChoices){
            dispatch(
                rootActions.main({
                    ShowSortChoices:false
                })
            )
        }

    }
    const size = useWindowSize();

    const PopUpWidht = (size.width !== undefined && size.width < MOBILE_BREAKPOINT) ? "100%" : "auto";

    return (
        <Popup iconWidth={"13px"} width={PopUpWidht} height="auto" canBeClosed={ true } close={props.close} bgClass="bg-dark-blue" styles={{borderRadius:"20px",overflowY:"hidden"}} >
            <div onClick={() => HideSortOptions(dispatch)}>
               {size.width !== undefined && size.width >= DESKTOP_BREAKPOINT  &&
                    <PluginsPopupLg />
                }
                {size.width !== undefined && size.width < DESKTOP_BREAKPOINT &&
                    <PluginsPopupMobile />
               }
            </div>
        </Popup>

    )
};